import { fetchHil } from "../utils";

const service = new google.maps.DistanceMatrixService();

function _getDistance(origin, destination, date, mode) {
  return new Promise((resolve, reject) => {
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: mode,
        drivingOptions: {
          departureTime: date,
        },
      },
      (response, status) => {
        if (status === "OK") {
          const travelTime = response.rows[0].elements[0].duration?.value;
          const travelDistance = response.rows[0].elements[0].distance?.value;
          resolve({ travelDistance, travelTime });
        } else {
          reject("error");
        }
      }
    );
  });
}

export async function calculateDistances(origin, destination) {
  const dateTransport = new Date();
  dateTransport.setDate(dateTransport.getDate() + 1);
  dateTransport.setHours(8);
  dateTransport.setMinutes(0);
  dateTransport.setMilliseconds(0);

  let distanceCar, distanceWalk, distanceTransport;
  let kmCar, kmWalk, kmTransport;

  try {
    const { travelTime, travelDistance } = await _getDistance(
      origin,
      destination,
      dateTransport,
      "DRIVING"
    );
    distanceCar = travelTime;
    kmCar = travelDistance;
  } catch (e) {
    console.warn("could not compute car distance");
  }

  try {
    const { travelTime, travelDistance } = await _getDistance(
      origin,
      destination,
      dateTransport,
      "WALKING"
    );
    distanceWalk = travelTime;
    kmWalk = travelDistance;
  } catch (e) {
    console.warn("could not compute walking distance");
  }

  try {
    const { travelTime, travelDistance } = await _getDistance(
      origin,
      destination,
      dateTransport,
      "TRANSIT"
    );
    distanceTransport = travelTime;
    kmTransport = travelDistance;
  } catch (e) {
    console.warn("could not compute transport distance");
  }

  return {
    distanceCar,
    distanceWalk,
    distanceTransport,
    kmCar,
    kmWalk,
    kmTransport,
  };
}

export async function addDistancesToLease(lease) {
  if (!lease.addressWork || !lease.actualCity) {
    return;
  }

  const {
    distanceTransport,
    kmTransport,
    kmWalk,
    distanceWalk,
    distanceCar,
    kmCar,
  } = await calculateDistances(lease.actualCity, lease.addressWork);

  const t = Math.min.apply(
    null,
    [distanceTransport, distanceWalk, distanceCar].filter((v) => v)
  );
  const d = Math.min.apply(
    null,
    [kmTransport, kmWalk, kmCar].filter((v) => v)
  );

  const patch = {
    lastContractualAddress1: lease.actualCity,
    lastContractualAddress2: lease.addressWork,
    contractualDistance: d,
    contractualTime: t,
  };

  const resp = await fetchHil(`/lease/${lease._id}`, {
    method: "PUT",
    body: patch,
  });
  if (!resp.ok) {
    let txt = await resp.text();
    console.error(txt);
    throw new Error(txt);
  }

  return patch;
}

export async function addDistancesToProposal(lease, host) {
  const addr = host.address;

  if (!lease.addressWork || !addr) {
    return;
  }

  const {
    distanceTransport,
    distanceWalk,
    distanceCar,
  } = await calculateDistances(addr, lease.addressWork);

  const resp = await fetchHil(
    `/proposals/lease/${lease._id}/host/${host._id}`,
    {
      method: "PUT",
      body: {
        distanceWalk,
        distanceTransport,
        distanceCar,
        lastGeocodingAddress: host.address,
      },
    }
  );
  if (!resp.ok) {
    let txt = await resp.text();
    console.error(txt);
    throw new Error(txt);
  }
}
